<template>
    <div class="information">
        <el-form
            ref="ruleForm"
            label-width="100px"
            style="overflow: hidden;"
            class="demo-ruleForm border-bottom margin-top2"
        >
        <el-row>
            <el-col :span="6">
                <el-form-item label="开始日期" prop="starttime">
                    <el-date-picker
                        @change="startTime"
                        v-model="ruleForm.startTimeString"
                        align="right"
                        type="date"
                        placeholder="选择开始日期"
                        format="yyyy-MM-dd HH:mm:ss"
                    ></el-date-picker>
                </el-form-item>
            </el-col>
            <el-col :span="6">
                <el-form-item label="结束日期" prop="Jieshutime">
                    <el-date-picker
                    @change="endTime"
                    v-model="ruleForm.endTimeString"
                    align="right"
                    type="date"
                    placeholder="选择结束日期"
                    format="yyyy-MM-dd HH:mm:ss"
                ></el-date-picker>
                </el-form-item>
            </el-col>
            </el-row>
            <el-row>
                <el-col :span="6">
                    <el-form-item label="采购状态" prop="Jieshutime">
                        <el-select v-model="procurementType" placeholder="请选择" style="width:220px;" @change="CGtype">
                            <el-option
                            v-for="item in PurchasingStatus"
                            :key="item.value"
                            :label="item.name"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="支付状态" prop="Jieshutime">
                        <el-select v-model="payType" placeholder="请选择" style="width:220px;" @change="ZFtype">
                            <el-option
                            v-for="item in payStatus"
                            :key="item.value"
                            :label="item.name"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="9">
                <el-form-item prop="searchInput" class="input">
                    <el-input v-model="ruleForm.searchInput" placeholder="采购单据、采购说明" style="width: 70%;"></el-input>
                    <el-button type="primary" @click="searchForm" style="margin-left:10px;">搜索</el-button>
                    <el-button type="primary" @click="resetFprm">重置</el-button>
                </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <el-row>
            <el-col :span="24" class="padding">
                <el-row :gutter="20">
                <el-col :span="4"><el-button type="primary" @click="AddOtherprocurementedit">新增采购</el-button></el-col>
                </el-row>
            </el-col>
        </el-row>
        
        <el-table :data="tableData" :header-cell-style="headClass" border style="width: 100%">
            <el-table-column prop="purchaseNumber" label="采购单号" align="center"></el-table-column>
            <el-table-column prop="purchaseInstructions" label="采购说明" align="center"></el-table-column>
            <el-table-column prop="roleUserName" label="采购人" align="center"></el-table-column>
            <el-table-column  width="80" label="采购状态" align="center">
                <template slot-scope="scope">
                    <span style="color: red;" v-if="scope.row.purchaseStatus == '1'">待采购</span>
                    <span style="color: #0565b7;" v-if="scope.row.purchaseStatus == '2'">已采购</span>
                    <span style="color: red;" v-if="scope.row.purchaseStatus == '3'">已发货</span>
                    <span style="color: #0565b7;" v-if="scope.row.purchaseStatus == '4'">已签收</span>
                    <span style="color: #0565b7;" v-if="scope.row.purchaseStatus == '5'">退货</span>
                </template>
            </el-table-column>
            <el-table-column width="80" label="支付状态" align="center">
                <template slot-scope="scope">
                    <span style="color: #0565b7;" v-if="scope.row.paymentStatus == '1'">已支付</span>
                    <span style="color: red;" v-if="scope.row.paymentStatus == '2'">未支付</span>
                </template>
            </el-table-column>
            <el-table-column prop="purchaseTotalAmount" label="采购总计" align="center"></el-table-column>
            <el-table-column prop="createTime" label="采购时间" align="center"></el-table-column>
            <el-table-column prop="updateTime" label="更新时间" align="center"></el-table-column>
            <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                    <el-button type="primary" @click="edit(scope.row)">采购编辑</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="page">
            <el-pagination
                style="margin-right:200px;"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[50, 100, 200, 400]"
                :page-size="pagesize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
            ></el-pagination>
        </div>
        <Otherprocurementedit ref="Otherprocurementedit" @Edit="search" />
        <AddOtherprocurementedit ref="AddOtherprocurementedit" @Add="search" />
    </div>
</template>

<script>
import AddOtherprocurementedit from "./Otherprocurementedit/AddOtherprocurementedit";
import Otherprocurementedit from "./Otherprocurementedit/Otherprocurementedit";
import { ajaxPost, Baseurl } from "../../api/api/api";
export default {
    name: "Orderpurchase",
    components: {
        Otherprocurementedit,
        AddOtherprocurementedit,
    },
    data() {
        return {
            headClass: this.common.headClass,
            procurementType:"",
            payType:"",

            currentPage: 1,
            pagesize: 50,
            size: 50,
            total: 0,

            PurchasingStatus:[
                {name:"待采购",value:"1"},
                {name:"已采购",value:"2"},
                {name:"已发货",value:"3"},
                {name:"已签收",value:"4"},
                {name:"退货",value:"5"},
            ],
            payStatus:[
                {name:"已支付",value:"1"},
                {name:"未支付",value:"2"},
            ],
            ruleForm: {
                startTimeString: "", //开始时间
                endTimeString: "", //结束时间
                searchInput: "", //全字段搜索
            },
            tableData: [],
        };
    },
    mounted() {},
    created() {
        this.str = JSON.parse(localStorage.getItem("role"));
        this.search()
    },
    methods: {
        edit(e) {
            this.$refs.Otherprocurementedit.init(e);
        },
        searchForm(){
            this.currentPage = 1
            this.search()
        },
        search() {
            var obj = {
                page:this.currentPage,
                size:this.size,
                startTime:this.ruleForm.startTimeString,
                endTime:this.ruleForm.endTimeString,
                searchString:this.ruleForm.searchInput,
                purchaseRoleId:this.str.rid,
                purchaseStatus:this.procurementType,
                paymentStatus:this.payType
            }
            ajaxPost(Baseurl + "generalProcurementController/selectGeneralProcurementInfo", obj).then(res => {
                this.tableData = res.data.data.pageInfo.list;
                this.total = res.data.data.pageInfo.total;
            });
        },
        resetFprm() {
            this.currentPage = 1
            this.ruleForm.startTimeString = ""
            this.ruleForm.endTimeString = ""
            this.ruleForm.searchInput = ""
            this.procurementType = ""
            this.payType = ""
            this.search()
        },
        CGtype(val){
            this.procurementType = val
        },
        ZFtype(val){
            this.payType = val
        },
        startTime(val) {
            var d = new Date(val);
            var datetime = d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate() + " 00:00:00";
            this.ruleForm.startTimeString = datetime;
            // console.log(this.ruleForm.startTimeString);
        },
        endTime(val) {
            var d = new Date(val);
            var datetime = d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate() + " 23:59:59";
            this.ruleForm.endTimeString = datetime;
            // console.log(this.ruleForm.endTimeString);
        },
        handleSizeChange(val) {
            // console.log(`每页 ${val} 条`);
            this.size = val;
            this.search()
        },
        handleCurrentChange(val) {
            // console.log(`当前页: ${val}`);
            this.currentPage = val;
            this.search()
        },
        AddOtherprocurementedit() {
            this.$refs.AddOtherprocurementedit.init();
        },
    },
};
</script>

<style lang="scss" scoped>
/deep/ {
    .layout .layout-section ::-webkit-scrollbar {
        width: 10px;
        height: 10px;
        background-color: #b71e1e;
    }
    .el-form-item__label {
        width: 120px !important;
    }
    .input .el-form-item__content{
        margin-left: 50px!important;
    }
}
.information {
    width: 98%;
    overflow: hidden;
}
.scope_img {
    width: 55px;
    height: 55px;
    img {
        width: 100%;
        height: 100%;
    }
}
.prduct_img {
    width: 500px;
    height: 500px;
}
.padding {
    padding: 10px 0;
}
.line-height {
    line-height: 45px;
}
.page {
    position: fixed;
    width: 100%;
    bottom: 0;
    background-color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 50px;
}
</style>
